import { getCurrentQuarter, getCurrentSchoolYear } from '../../utils/quarterUtils';

// Action Types
export const SET_CURRENT_QUARTER = 'SET_CURRENT_QUARTER';
export const SET_SCHOOL_YEAR = 'SET_SCHOOL_YEAR';
export const SET_SCHOOL_YEAR_ID = 'SET_SCHOOL_YEAR_ID';
export const INITIALIZE_QUARTER = 'INITIALIZE_QUARTER';
export const SET_QUARTER_LOADING = 'SET_QUARTER_LOADING';
export const SET_QUARTER_ERROR = 'SET_QUARTER_ERROR';

// Action Creators
const QuarterA = (dispatch) => {
  return {
    /**
     * Set the current quarter
     * @param {number} quarter - Quarter number (1-4)
     */
    setCurrentQuarter: (quarter) => {
      dispatch({
        type: SET_CURRENT_QUARTER,
        payload: quarter
      });
    },

    /**
     * Set the school year
     * @param {number} schoolYear - School year (e.g., 2024)
     */
    setSchoolYear: (schoolYear) => {
      dispatch({
        type: SET_SCHOOL_YEAR,
        payload: schoolYear
      });
    },

    /**
     * Set the school year ID (from database)
     * @param {string} schoolYearId - School year ID from database
     */
    setSchoolYearId: (schoolYearId) => {
      dispatch({
        type: SET_SCHOOL_YEAR_ID,
        payload: schoolYearId
      });
    },

    /**
     * Initialize quarter and school year based on current date
     */
    initializeQuarter: () => {
      dispatch({
        type: INITIALIZE_QUARTER,
        payload: {
          quarter: getCurrentQuarter(),
          schoolYear: getCurrentSchoolYear()
        }
      });
    },

    /**
     * Set quarter loading state
     * @param {boolean} loading - Loading state
     */
    setQuarterLoading: (loading) => {
      dispatch({
        type: SET_QUARTER_LOADING,
        payload: loading
      });
    },

    /**
     * Set quarter error state
     * @param {string|null} error - Error message or null
     */
    setQuarterError: (error) => {
      dispatch({
        type: SET_QUARTER_ERROR,
        payload: error
      });
    },

    /**
     * Update quarter and trigger data refresh
     * @param {number} quarter - New quarter number
     * @param {Function} callback - Optional callback function
     */
    changeQuarter: (quarter, callback = null) => {
      dispatch({
        type: SET_CURRENT_QUARTER,
        payload: quarter
      });
      
      if (callback && typeof callback === 'function') {
        callback(quarter);
      }
    },

    /**
     * Update school year and trigger data refresh
     * @param {string} schoolYearId - New school year ID
     * @param {number} schoolYear - New school year
     * @param {Function} callback - Optional callback function
     */
    changeSchoolYear: (schoolYearId, schoolYear, callback = null) => {
      dispatch({
        type: SET_SCHOOL_YEAR_ID,
        payload: schoolYearId
      });
      
      dispatch({
        type: SET_SCHOOL_YEAR,
        payload: schoolYear
      });
      
      if (callback && typeof callback === 'function') {
        callback(schoolYearId, schoolYear);
      }
    }
  };
};

export default QuarterA;